function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-2672.904 382.226)"
}, React.createElement("path", {
  d: "M2682.536-364.882q-.256,1.216-2.848,1.216a32.8,32.8,0,0,1-4.688-.3q-2.1-.3-2.1-.944a8.732,8.732,0,0,1,1.344-2.4q1.345-2.016,4.065-5.664a83.854,83.854,0,0,1-5.121-7.3q0-.607,2.241-1.28a13.571,13.571,0,0,1,3.775-.672,6.175,6.175,0,0,1,2.384.368q.847.369.944.816l1.408,4.9h.288l.512-4.608q.033-.192.752-.528a11.086,11.086,0,0,1,1.937-.64,9.59,9.59,0,0,1,2.336-.3q4.222,0,4.223,1.44a8.67,8.67,0,0,1-1.248,2.512q-1.248,2.064-3.744,5.744,5.312,7.2,5.313,7.616,0,1.248-3.617,1.248-5.6,0-5.856-1.216l-1.248-4.192h-.224Z",
  fill: "#ffc800"
}));

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 21.409,
    height: 18.56,
    viewBox: "0 0 21.409 18.56",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.0b0806ca.svg";
export { ForwardRef as ReactComponent };